import { gboReservationPath, gmaSessionPath } from 'paths/session';

export const inPathAdditionalDriversPath = [...gboReservationPath, 'additional_drivers'];

export const numberAdditionalDriversAllowedPath = [...gboReservationPath, 'number_of_additional_drivers_allowed'];

export const gmaAdditionalDriversPath = [...gmaSessionPath, 'additional_drivers'];
